import UltMeta, { Meta } from "@/meta/UltMeta/index";

class ShipState extends UltMeta {
    PENDING_APPROVAL = new Meta(1, "待审核");
    NOT_PASS = new Meta(2, "未通过");
    PASSED = new Meta(3, "已通过");
    DISABLED = new Meta(4, "已禁用");
    CLOSED = new Meta(5, "已关闭");
    WAITING_FOR_ORDERS = new Meta(6, "候单");
    RECEIVING_ORDERS = new Meta(7, "报价");
}

export const Ship_STATE = new ShipState();

class ShipSelectState extends UltMeta {
    PENDING_APPROVAL = new Meta(1, "待审核");
    NOT_PASS = new Meta(2, "未通过");
    PASSED = new Meta(3, "已通过");
    DISABLED = new Meta(4, "已禁用");
    CLOSED = new Meta(5, "已关闭");
}

export const Ship_SELECT_STATE = new ShipSelectState();

class DeviceState extends UltMeta {
    OFF_LINE = new Meta(0, "已离线");
    WORKING = new Meta(1, "运行中");
    DISABLED = new Meta(2, "已禁用");
}
export const DEVICES_STATE = new DeviceState();

class DeviceType extends UltMeta {
    VIDEO = new Meta(0, "摄像头");
    GPS = new Meta(1, "GPS");
}
export const DEVICES_TYPE = new DeviceType();

class ShipType extends UltMeta {
    VIDEO = new Meta(0, "船舶");
    CAR = new Meta(1, "汽车");
}
export const SHIP_TYPE = new ShipType();

class PhotoType extends UltMeta {
    CERTIFICATE_URL = new Meta("certificateFileId", "船舶营业运输证");
    SHIP_URL = new Meta("shipFileIds", "船只图片");
    ID_CARD_FRONT_URL = new Meta("idCardFrontFileId", "负责人身份证反面");
    ID_CARD_BACK_URL = new Meta("idCardBackFileId", "负责人身份证反面");
}
export const PHOTO_TYPE = new PhotoType();

class ApplyState extends UltMeta {
    PENDING_APPROVAL = new Meta(1, "待审核");
    REJECTED = new Meta(2, "已驳回");
    PASSED = new Meta(3, "已通过");
}

export const APPLY_STATE = new ApplyState();

/**
 * 关联设备
 */
class RelatedDevice extends UltMeta {
    ALL = new Meta(1, "全部");
    YES = new Meta(2, "是");
    NO = new Meta(3, "否");
}

export const RELATED_DEVICE = new RelatedDevice();
